import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const ActivitySearchContext = createContext(null);

export const ActivitySearchProvider = ({ children }) => {
  const [searchValue, setSearchValueState] = useState('');
  const [isExpanded, setIsExpanded] = useState(false);
  const onCreateNoteRef = useRef(null);

  const setSearchValue = useCallback((value) => {
    setSearchValueState((prev) => (typeof value === 'function' ? value(prev) : value));
  }, []);

  const registerCreateNoteHandler = useCallback((fn) => {
    onCreateNoteRef.current = fn;
    return () => {
      onCreateNoteRef.current = null;
    };
  }, []);

  const requestCreateNote = useCallback(() => {
    onCreateNoteRef.current?.();
  }, []);

  const value = {
    searchValue,
    setSearchValue,
    isExpanded,
    setIsExpanded,
    registerCreateNoteHandler,
    requestCreateNote,
  };

  return (
    <ActivitySearchContext.Provider value={value}>
      {children}
    </ActivitySearchContext.Provider>
  );
};

export const useActivitySearch = () => {
  const context = useContext(ActivitySearchContext);
  if (!context) {
    throw new Error('useActivitySearch must be used within ActivitySearchProvider');
  }
  return context;
};
